import { BasePagePath } from 'app/core/workflow/page-path/base-page.path';

export class RateAppPagePath extends BasePagePath {
  public static path(): string {
    return 'rate-app';
  }
}
